import * as React from 'react';

import { Root } from './styled';


export type SpacerProps = {
	size: number | string;
	appearance?: 'horizontal' | 'vertical' | 'all';
};

const Spacer: React.FC<SpacerProps> = ({ appearance, size }) => {
	return (
		<Root appearance={appearance} size={size} />
	);
}

Spacer.displayName = 'Spacer';
Spacer.defaultProps = {
	appearance: 'horizontal',
};

export default Spacer;
